import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Spinner, Modal, Tab, Nav } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Skeleton from '../../Common/Skeleton';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import Edit from '../../../Assets/Edit.svg';
import Delete from '../../../Assets/Delete.svg';
import { setLogout } from '../../Auth/LoginSlice';
import { setActiveKey } from '../../Common/ActiveKeySlice';
import PublishModel from '../../Common/Model/PublishModel';
import UnPublishModel from '../../Common/Model/UnPublishModel';
import useDebouncedApiCall from '../../Common/Reuse/Debounce';
import ChromeTabShortDesc from '../../Common/langugageToggle/ChromeTabShortdesc';
import ButtonComponent from '../../Common/Button/ButtonComponent';
import DeleteModel from '../../Common/Model/DeleteModel';
import PaginationSequence from '../../Common/Pagination/PaginationSequence';
import * as XLSX from 'xlsx';
import sampleFile from "./sampleFile.xlsx";
import { setPageNo, setDocPerPage, resetData } from '../../Common/PaginationSlice';

const GuruQuote = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userState = useSelector((state) => state?.cmsLogin?.userData?.data);
  // for pagination
  const pageNo = useSelector((state) => state.pagination.pageNo);
  const docPerPage = useSelector((state) => state.pagination.docPerPage);


  const [showAdd, setShowAdd] = useState(false);
  const [delId, setDelId] = useState('');
  const [showDel, setShowDel] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const [guru, setGuru] = useState('');
  const [guruQuoteId, setGuruQuoteId] = useState('');
  const [quoteEn, setQuoteEn] = useState('');
  const [quoteMr, setQuoteMr] = useState('');
  const [quoteHn, setQuoteHn] = useState('');
  const [date, setDate] = useState('');
  const [guruId, setGuruId] = useState('');
  const [guruFirstName, setGuruFirstName] = useState('');
  const [guruLastName, setGuruLastName] = useState('');
  const [guruImageURL, setGuruImageURL] = useState('');
  const [guruOptions, setGuruOptions] = useState([]);
  const [searchField, setSearchField] = useState("");
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
  const [guruQuoteID, setGuruQuoteID] = useState(null);
  // Unpublish Article variables
  const [isUnpublish, setIsUnpublish] = useState(false);
  const [unpublishId, setUnpublishId] = useState("");

  const [guruQuotes, setGuruQuotes] = useState([]);
  const [fileName, setFileName] = useState('');

  const [key, setKey] = useState('singleQuote');

  const [error, setErrors] = useState({});


  // States for Pagination ----------
  const [noOfPages, setNoOfPages] = useState();

  useEffect(() => {
    getGuruList();
  }, []);


  // Function to handle opening the publish modal
  const openPublishModal = (guruQuoteId) => {
    setGuruQuoteID(guruQuoteId);
    setIsPublishModalOpen(true);
  };

  const handlePublishModalCancel = () => {
    setIsPublishModalOpen(false);
  };

  // Function to handle opening the unpublish modal
  const openUnpublishModal = (guruQuoteID) => {
    setUnpublishId(guruQuoteID);
    setIsUnpublish(true);
  };

  // Function to handle cancelling the unpublish modal
  const closeUnpublishModal = () => {
    setIsUnpublish(false);
  };

  const getGuruList = async () => {
    try {
      const result = await fetch(process.env.REACT_APP_BASE_URL + '/cms/getAllGuru', {
        method: 'GET',
        headers: { Authorization: `Bearer ${userState?.token}` }
      })
      const response = await result.json();
      if (response.status === 200) {
        let arr = [];
        response.data.map((row) => {
          arr.push({
            ...row,
            label: row.firstName + ' ' + row.lastName, value: row.guruId,
          });
        });
        setGuruOptions(arr);
      }
    } catch (Err) {
      console.log("Err while getting  guru list", Err);
    }
  }

  useEffect(() => {
    getAllQuotes()
  }, [pageNo, docPerPage])

  // ------- Get All Activities ----------------------
  const getAllQuotes = async () => {
    try {
      setLoader(true);
      const response = await fetch(process.env.REACT_APP_BASE_URL + '/priority/titleFilter', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${userState?.token}`
        },
        body: JSON.stringify({
          courseTeacherId: '',
          courseCategories: '',
          type: "Guru Quote",
          title: searchField ? searchField : "",
          documentsPerPage: docPerPage,
          page: pageNo
        })
      })
      const responseData = await response.json();
      if (responseData.message === "Authorization failed / Forbidden") {
        setLoader(true);
        dispatch(setLogout(null));
        dispatch(setActiveKey(null));

        localStorage.removeItem('persist:root');
        navigate('/');
      } else {
        setData(responseData);
        setNoOfPages(responseData?.noOfPages);
        setLoader(false);
      }

    } catch (Err) {
      console.log("Err while getting activites", Err);
      setLoader(false);
    }
  }

  // for debounding
  const dependencies = [searchField ? searchField : ""];
  useDebouncedApiCall(getAllQuotes, dependencies, setLoader);

  const addValidate = () => {
    let newErrors = {};

    if (!guru) {
      newErrors.guru = "*Please select guru";
    }

    if (!date) {
      newErrors.date = "*Please enter guru quote date";
    }

    if ((!quoteMr || quoteMr.trim() === '<p><br></p>') ||
      (!quoteEn || quoteEn.trim() === '<p><br></p>'))
    // (!quoteHn || quoteHn.trim() === '<p><br></p>') ||
    {
      newErrors.description = "* descriptions in English and Marathi are required";
    }


    setErrors(newErrors);
    if (newErrors) {
      document.getElementById(Object.keys(newErrors)[0])?.scrollIntoView({ behavior: 'smooth' });
    }
    return Object.keys(newErrors).length === 0;
  }

  const editValidate = () => {
    let newErrors = {};

    if (!date) {
      newErrors.date = "*Please enter guru quote date";
    }

    if ((!quoteMr || quoteMr.trim() === '<p><br></p>') ||
      (!quoteEn || quoteEn.trim() === '<p><br></p>'))
    // (!quoteHn || quoteHn.trim() === '<p><br></p>') ||
    {
      newErrors.description = "*Both short and full descriptions in English and Marathi are required";
    }

    setErrors(newErrors);
    if (newErrors) {
      document.getElementById(Object.keys(newErrors)[0])?.scrollIntoView({ behavior: 'smooth' });
    }
    return Object.keys(newErrors).length === 0;
  }


  const addGuruQuote = async (status) => {
    const isValid = addValidate();

    if (isValid) {
      try {
        setLoader(true);
        const result = await fetch(process.env.REACT_APP_BASE_URL + '/guruQuote/createGuruQuote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userState?.token}` },
          body: JSON.stringify({
            guruFirstName: guru?.firstNameLang?.mr,
            guruLastName: guru?.lastNameLang?.mr,
            guruFirstNameLang: { en: guru?.firstNameLang?.en, mr: guru?.firstNameLang?.mr, hin: guru?.firstNameLang?.hin },
            guruLastNameLang: { en: guru?.lastNameLang?.en, mr: guru?.lastNameLang?.mr, hin: guru?.lastNameLang?.hin },
            guruImageURL: guru?.imgURL,
            quote: quoteMr,
            quoteLang: { en: quoteEn, mr: quoteMr, hin: quoteHn },
            guruId: guru?.guruId,
            date: date,
            createdBy: userState?.user?.name,
            isPublish: status
          })
        });

        const response = await result.json();
        if (response?.message === "guruQuote Created Successfully") {
          toast.success("Guru Created Successfully");
          setLoader(false);
          closeModal();
          getAllQuotes();
        }
        else if (response?.message === "Guru Qoute Limit Exceeded") {
          toast.error("Guru Qoute Limit Exceeded");
          setLoader(false);
          closeModal();
          getAllQuotes();
        }
        else {
          toast.error("Failed to add guru, please try again");
          setLoader(false);
          closeModal();
        }
      } catch (Err) {
        console.log("Error  in adding Guru", Err);
        setLoader(false);
        closeModal();
      }
    }
  }

  const setUpdateData = (itm) => {

    setShowEdit(true)
    const name = itm.guruFirstName + " " + itm.guruLastName;
    setGuru({ label: name, value: name });
    setGuruId(itm.guruId);
    setDate(moment(itm.date).format("YYYY-MM-DD"));
    setQuoteEn(itm.quoteLang.en);
    setQuoteMr(itm.quoteLang.mr ? itm.quoteLang.mr : "");
    setQuoteHn(itm.quoteLang.hin ? itm.quoteLang.hin : "");
    setGuruQuoteId(itm.guruQuoteId);
    setGuruFirstName(itm.guruFirstName);
    setGuruLastName(itm.guruLastName);
    setGuruImageURL(itm.guruImageURL);


  }

  const editGuruQuote = async (status) => {
    const isValid = editValidate();

    if (isValid) {
      try {
        setLoader(true);
        const result = await fetch(process.env.REACT_APP_BASE_URL + '/guruQuote/updateGuruQuote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userState?.token}` },
          body: JSON.stringify({
            guruQuoteId: guruQuoteId,
            quote: quoteMr,
            quoteLang: { en: quoteEn, mr: quoteMr, hin: quoteHn },
            guruId: guruId,
            guruFirstName: guruFirstName,
            guruLastName: guruLastName,
            guruImageURL: guruImageURL,
            date: date,
            createdBy: userState?.user?.name,
            updatedBy: userState?.user?.userId,
            isPublish: status
          })
        });

        const response = await result.json();
        if (response?.message === "Updated Successfully") {
          toast.success("Guru Quote Updated Successfully");
          setLoader(false);
          closeModal();
          getAllQuotes();
        }
        else if (response?.message === "Guru Qoute Limit Exceeded") {
          toast.error("Guru Qoute Limit Exceeded");
          setLoader(false);
          closeModal();
          getAllQuotes();
        }
        else {
          toast.error("Failed to edit guru quote, please try again");
          setLoader(false);
          closeModal();
        }
      } catch (Err) {
        console.log("Error in updating Guru quote", Err);
        setLoader(false);
        closeModal();
      }
    }
  }

  const deleteGuru = async () => {
    setLoader(true);
    try {
      const result = await fetch(process.env.REACT_APP_BASE_URL + '/guruQuote/deleteGuruQuote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userState.token}`
        },
        body: JSON.stringify({ guruQuoteId: delId })
      });
      const response = await result.json();
      if (response.message === 'Data deleted succussfully') {
        toast.success('Guru Quote Deleted Succussfully');
        setShowDel(false);
        setDelId('');
        setLoader(false);
        getAllQuotes();
      }
      else {
        toast.error('Failed to delete, try again');
        setShowDel(false);
        setDelId('');
        setLoader(false);
      }
    } catch (Err) {
      console.log("Err while deleting guru quote", Err);
      setLoader(false);
    }
  }


  //----- Setting up Closing modal & Clearing Values ----//
  const closeModal = () => {
    setGuru('');
    setDate('');
    setQuoteEn('');
    setQuoteMr('');
    setQuoteHn('');
    setShowAdd(false);
    setShowEdit(false);
  }


  // Function for handling page change
  const handlePageChange = (pageNumber) => {
    dispatch(setPageNo(pageNumber));
  };

  // Function for handling docsper page change
  const handleDocsPerPage = (docsPageProp) => {
    dispatch(setPageNo(1));
    dispatch(setDocPerPage(docsPageProp));
  };

  // Function to handle confirming publish or unpublish modal
  const handlePublishAction = async (guruQuoteId, isPublish) => {
    try {
      setIsPublishModalOpen(false);
      setIsUnpublish(false);
      const result = await fetch(process.env.REACT_APP_BASE_URL + "/guruQuote/publishGuruQuote", {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState?.token}` },
        body: JSON.stringify({
          guruQuoteId: guruQuoteId,
          isPublish: isPublish
        }),
      });

      const response = await result.json();
      if (response) {
        getAllQuotes();
      } else {
        console.log("Error toggling publish status");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Function to handle confirming publish modal
  const handlePublishModalConfirm = async (status) => {
    await handlePublishAction(guruQuoteID, status);
  };

  // Function to handle confirming unpublish modal
  const handleUnpublishConfirm = async (status) => {
    await handlePublishAction(unpublishId, status);
  };



  const addGuruQuoteBulk = async (status) => {
    if (!fileName) {
      toast.error('Please select a file');
      setFileName('');
      return;
    } else {
      try {
        const response = await fetch(process.env.REACT_APP_BASE_URL + "/cms/bulkCreateGuruQuotes", {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userState?.token}` },
          body: JSON.stringify({
            data: guruQuotes,
            isPublish: status,
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to add guru quotes');
        }

        const data = await response.json();
        if (data.message === "Bulk Guru Quotes Processed Successfully") {
          toast.success("Upload successfully")
          setGuruQuotes([]);
          setFileName('');
          closeModal();
          getAllQuotes();
        } else {

        }

      } catch (error) {
        console.error('Error adding guru quotes:', error.message);

      }
    }
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      console.log({
        data: jsonData,
        isPublish: ''
      });

      setGuruQuotes(jsonData);
      toast.success('File uploaded successfully!');
    };

    reader.readAsArrayBuffer(file);
  };


  const triggerFileInput = () => {
    document.getElementById('bulkFileInput').click();
  };


  return (
    <div className='GuruQuote'>
      <ToastContainer />
      <PublishModel
        isOpen={isPublishModalOpen}
        onClose={handlePublishModalCancel}
        onConfirm={handlePublishModalConfirm}
        title="GuruQuote"
        loader={loader}
      />
      <UnPublishModel
        isOpen={isUnpublish}
        onClose={closeUnpublishModal}
        onConfirm={handleUnpublishConfirm}
        title="GuruQuote"
        loader={loader}
      />
      <DeleteModel
        show={showDel}
        onHide={() => { setShowDel(false); setDelId(''); }}
        onDelete={deleteGuru}
        loader={loader}
        label="Guru Quote"
      />
      <ToastContainer />
      <Container>
        <Row className='justify-content-between'>
          <Col md={4} className="mb-2 mb-sm-0">
            <input
              className="form-control"
              type="text"
              placeholder="Search here"
              name="search"
              value={searchField}
              onChange={(e) => {
                if (e.target.value.trim()) {
                  setSearchField(e.target.value)
                  dispatch(setPageNo(1));
                } else if (e.target.value.length === 0) {
                  setSearchField(e.target.value)
                  dispatch(setPageNo(1));
                }
              }}
            ></input>
          </Col>
          <Col md={3} className='d-flex justify-content-end my-auto mt-3 mt-md-0'>
            <Button className='primaryBtn' onClick={() => setShowAdd(true)}>
              <Icon.ChatQuote className='me-2' size={16} />Add Guru Quote
            </Button>
          </Col>
        </Row>


        <div className="outer-wrapper mx-auto mt-4">
          <div className="table-wrapper" style={{ maxHeight: '65vh' }}>
            <table>
              <thead>
                <th>Sr.</th>
                <th>Name</th>
                <th>Quote</th>
                <th>Date</th>
                <th>Publish</th>
                <th>Action</th>
              </thead>
              {
                loader ? <Skeleton rows={10} cols={6} /> :
                  data?.data !== null && data?.data !== undefined && data?.data.length > 0 ? data?.data?.map((itm, index) => {
                    const { guruQuoteId, guruImageURL, guruFirstName, guruLastName, quote, status, date } = itm
                    return (

                      <tr key={Math.random() * 999999999}>
                        <td>{pageNo !== 1 ? (
                          <>
                            {' '}
                            {index + 1 + docPerPage * (pageNo - 1)}
                          </>
                        ) : (
                          <>{index + 1}</>
                        )}</td>
                        <td>{guruFirstName + ' ' + guruLastName}</td>
                        <td style={{ width: '300px' }}><div
                          dangerouslySetInnerHTML={{
                            __html: quote,
                          }}
                        ></div></td>
                        <td>{moment(date).format('DD-MM-YYYY')}</td>
                        <td style={{ width: '120px' }}>
                          {itm.isPublish ? (
                            <div
                              style={{
                                backgroundColor: "#8FBC8F",
                                borderRadius: "8px",
                                padding: "4px 8px",
                                color: "white",
                                textAlign: "center",
                                cursor: "pointer"
                              }}
                              onClick={() => openUnpublishModal(itm.guruQuoteId)}
                            >
                              Published
                            </div>
                          ) : (
                            <div
                              className="switch"
                              onClick={() => openPublishModal(itm.guruQuoteId)}
                            >
                              <input type="checkbox" checked={itm.publish} onChange={() => { }} />
                              <span className="slider round" onClick={() => openPublishModal(itm.guruQuoteId)}></span>
                            </div>
                          )}

                        </td>

                        <td className="d-flex">
                          {/* <img src={View} alt="View" className='icon me-3'/> */}
                          <img src={Edit} alt="Edit" className='icon me-3'
                            onClick={() => setUpdateData(itm)} />
                          <img src={Delete} alt="Delete" className='icon'
                            onClick={() => { setShowDel(true); setDelId(guruQuoteId); }} />
                        </td>
                      </tr>
                    )
                  })
                    : <p className='noDataFound'>No Data Found</p>
              }
            </table>
          </div>
        </div>

        <PaginationSequence
          data={data?.count}
          pageNo={pageNo}
          noOfPages={noOfPages}
          handlePageChange={handlePageChange}
          handleDocsPerPage={handleDocsPerPage}
          docPerPage={docPerPage}
        />

      </Container>

      {/*  ------------------- Add Guru Modal ------------------------ */}

      <Modal size={key === "singleQuote" ? 'xl' : 'md'} show={showAdd} backdrop='static' keyboard={false} centered onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className='mb-0'>
              <Icon.ChatQuote size={20} className='me-2' />Add Guru Quote
            </h4>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
            <div className='GuruAndQuotes mb-3'>
              <Nav variant="pills" className="flex-row justify-content-center mx-auto">
                <Nav.Item>
                  <Nav.Link eventKey="singleQuote">
                    <Icon.Person className='me-2' />Single Guru Quote
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="bulkInsert">
                    <Icon.ChatQuote className='me-2' />Multiple Insert Guru Quotes
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>

            <Tab.Content>
              <Tab.Pane eventKey="singleQuote">
                <Row className='justify-content-center'>
                  <Col md={6}>
                    <Form.Group className='mb-3'>
                      <Form.Label>Select Guru<span>*</span></Form.Label>
                      <Select
                        isMulti={false}
                        id="guru"
                        value={guru}
                        onChange={setGuru}
                        options={guruOptions}
                        placeholder="Select Guru"
                      />
                      {error.guru && <p className="errMsg">{error.guru}</p>}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className='mb-3'>
                      <Form.Label>Guru Quote Date<span className='errMsg'>*</span></Form.Label>
                      <Form.Control id="date" type='date' value={date} onChange={(e) => setDate(e.target.value)} />
                      {error.date && <p className="errMsg">{error.date}</p>}
                    </Form.Group>
                  </Col>

                  {/* for description  */}
                  <ChromeTabShortDesc
                    shortdescriptionMr={quoteMr}
                    setShortDescriptionMr={setQuoteMr}
                    shortdescription={quoteEn}
                    setShortDescription={setQuoteEn}
                    shortdescriptionHn={quoteHn}
                    setShortDescriptionHn={setQuoteHn}
                    label="Short"
                  />
                </Row>

                {error.description && <p className="errMsg mt-1">{error.description}</p>}
              </Tab.Pane>

              <Tab.Pane eventKey="bulkInsert">
                <Row className="justify-content-end mt-3">
                  <Col md={12}>
                    <div className="d-flex justify-content-end align-items-center">
                      <a className='downloadSample'
                        href={sampleFile}
                        download="sampleFile"
                      >
                        <Icon.CloudArrowDownFill className="me-2" size={18} />
                        Download Sample File
                      </a>
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center mt-3">
                  <Col md={8}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '40px',
                      }}
                    >
                      <Icon.CloudArrowUpFill size={50} style={{ color: '#FD6E47' }} />
                      <h5>Insert your file here</h5>
                      <h6 style={{ color: 'grey' }}>File supported : XLSX</h6>
                      <Button className=" d-flex align-items-center " onClick={triggerFileInput} id="uploadBtn">
                        <Icon.BoxArrowInDown size={20} className="me-2" />
                        Insert Bulk Guru Quote
                      </Button>
                      <input
                        type="file"
                        id="bulkFileInput"
                        style={{ display: 'none' }}
                        accept=".xlsx, .xls"
                        onChange={handleFileUpload}
                      />
                      {fileName && <p className="mt-2"><b>Selected File:</b> {fileName}</p>}
                    </div>
                  </Col>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>

        <Modal.Footer>
          {loader ? <Spinner variant='primary' /> :
            <ButtonComponent
              onSave={key === 'singleQuote' ? addGuruQuote : addGuruQuoteBulk}
              onSaveAndPublish={key === 'singleQuote' ? addGuruQuote : addGuruQuoteBulk}
              saveLabel="Save"
              savePublish="Save & Publish"
            />
          }
        </Modal.Footer>
      </Modal>

      {/*  ------------------- Edit Guru Modal ------------------------ */}
      <Modal size='xl' show={showEdit} backdrop='static' keyboard={false} centered onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title> <h4 className='mb-0'>
            <Icon.ChatQuote size={20} className='me-2' />Edit Guru Qoute</h4>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className='justify-content-center'>
            <Col md={6}>
              <Form.Group className='mb-3'>
                <Form.Label>Select Guru<span>*</span></Form.Label>
                <Select
                  isMulti={false}
                  id="guru"
                  value={guru}
                  isDisabled={true}
                  onChange={setGuru}
                  options={guruOptions}
                  placeholder="Select Guru"
                />
                {error.guru && <p className="errMsg">{error.guru}</p>}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className='mb-3'>
                <Form.Label><span className='errMsg'>*</span>Guru Quote Date</Form.Label>
                <Form.Control id="date" type='date' value={date} onChange={(e) => {
                  setDate(e.target.value)
                }} />
                {error.date && <p className="errMsg">{error.date}</p>}
              </Form.Group>
            </Col>

            {/* for description  */}
            <ChromeTabShortDesc
              shortdescriptionMr={quoteMr}
              setShortDescriptionMr={setQuoteMr}
              shortdescription={quoteEn}
              setShortDescription={setQuoteEn}
              shortdescriptionHn={quoteHn}
              setShortDescriptionHn={setQuoteHn}
            />
          </Row>

          {error.description && (
            <p className="errMsg mt-1">{error.description}</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          {
            loader ? <Spinner variant='primary' /> :
              <ButtonComponent
                onSave={editGuruQuote}
                onSaveAndPublish={editGuruQuote}
                saveLabel="Update"
                savePublish="Update & Publish"
              />
          }
        </Modal.Footer>
      </Modal>

    </div >
  )
}

export default GuruQuote;